// removed by extract-text-webpack-plugin
module.exports = {"Icon":"_3Q13gTT3v2M8xfmsdEi-wR","QuestionBody":"_1RDJJGQawFhSWxt5JAAEVY","FeedbackStatsText":"_1dz_as7eTRod5YUeuMmupj","QuestionTitle":"_3n3qX5yRzDDje-pjR8ESEU","LiveText":"_2a_K2l8Rw9cM7nPRaC5QvQ"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/FAQ/Helpdesk/Feedback/Questions/QuestionItem/style.css
// module id = 2043
// module chunks = 0